/** Display strings for the 11 AstdZ standards with trademark symbols. Use on first mention per page/component. */
export const STANDARDS_DISPLAY = {
  EMRG: 'EMRG\u2122',
  POLI: 'POLI\u2122',
  ENGY: 'ENGY\u2122',
  H2OQ: 'H2OQ\u2122',
  TRAX: 'TRAX\u2122',
  AGRO: 'AGRO\u2122',
  STRX: 'STRX\u2122',
  MEDI: 'MEDI\u2122',
  COLD: 'COLD\u2122',
  ATMO: 'ATMO\u2122',
  WTHR: 'WTHR\u2122',
} as const;
